import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import './FeedMappingList.scss';
import EditButton from './EditButton';
import AddButton from './AddButton';
import ErrorMessage from '../ErrorMessage';
import SuccessMessage from '../SuccessMessage';

class FeedMappingList extends PureComponent {
  actionFormatter = (cell, feedMapping) => (
    <EditButton
      feedMapping={feedMapping}
      onEdit={this.props.onEdit}
      onDelete={this.props.onDelete}
    />
  );

  createCustomInsertButton = () => <AddButton />;

  render() {
    const { list, error, success } = this.props;

    const options = {
      insertBtn: this.createCustomInsertButton,
      defaultSortName: 'type',
      defaultSortOrder: 'asc',
    };

    return (
      <div className="feed-mapping-list-container">
        {error && <ErrorMessage error={error} />}
        {success && <SuccessMessage success={success} />}
        <BootstrapTable
          data={list}
          options={options}
          insertRow
          striped
          hover
          pagination
          bodyContainerClass="list-body-container"
          tableStyle={{ border: 'none' }}
        >
          <TableHeaderColumn
            isKey
            dataField="type"
            dataSort
            filter={{ type: 'TextFilter', defaultValue: '' }}
          >
            Type
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="button"
            columnClassName="list-action-column"
            dataFormat={this.actionFormatter}
          />
        </BootstrapTable>
      </div>
    );
  }
}

FeedMappingList.propTypes = {
  error: PropTypes.any,
  success: PropTypes.any,
  list: PropTypes.array,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
};

export default withRouter(FeedMappingList);
